import { SensorGroups } from "@station/domain/models/sensor-group.model";
import type { SensorGroupRepository } from "@station/domain/repositories/sensor-group.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class SensorGroupGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.SensorGroupRepository)
        private readonly sensorGroupRepository: SensorGroupRepository,
    ) {}

    async execute(stationId: string): Promise<SensorGroups> {
        const sensorGroupResult =
            await this.sensorGroupRepository.getAll(stationId);

        return sensorGroupResult.match(
            (sensorGroups) => sensorGroups,
            () => SensorGroups.empty(),
        );
    }
}
